import { getParam, setStorage, getStorage } from './tools'
import Cookies from 'js-cookie';
import {AD_ID_COOKIES_KEY, IS_TOUFANG_STORE_KEY, USER_ID_COOKIES_KEY, USER_TOKEN_COOKIES_KEY, PLAY_TEMPLATE} from './constant'

// 图片地址
export const IMG_BASE_URL = 'https://static.novelfreedom.com/';
export const LOCAL_IMG_URL = 'https://static.novelfreedom.com/paynovel/video/';
// https://static.novelfreedom.com/paynovel/h5-pay-asia/


// 获取版本号
export const getVersion = () => {
    return '1.2.0'
}

// 获取fb pixel id
export const getFbPixelId = () => {
    return APP_CONFIG[getAppID()]?.fbPixleId || APP_CONFIG['default'].fbPixleId
}

export const getTtPixelId = () => {
    return APP_CONFIG[getAppID()]?.ttPixelId || APP_CONFIG['default'].ttPixelId
}

export const getPathLang = () => {
    const app = getAppID();
    return APP_CONFIG[app]?.lang || APP_CONFIG['default'].lang || 'en'
}

export const getAppID = ()=>{
    // return 'polardrama'
    if(process.env.NODE_ENV === 'dev'){
        return 'melonflix'
    }
    if(process.env.VUE_APP_ENV === 'test'){
        return 'melonflix'
    }
    let host = location.host && location.host.split('.'); 
    
    return host.length < 2 ? "" : host[host.length -2];
}


export const setCookieFbc = () => {
    const urlParams = new URLSearchParams(window.location.search);
    const fbclid = urlParams.get('fbclid');
    if (fbclid) {
        const fbc = `fb.1.${Date.now()}.${fbclid}`;
        document.cookie = `_fbc=${encodeURIComponent(fbc)}; max-age=7776000; path=/; SameSite=Lax`;
    }
}

export const setCookieAdId = () => {
    const adId = getParam('af_ad_id');
    if (adId) {
        Cookies.set(AD_ID_COOKIES_KEY, adId, { expires: 365, path: '/' });
    }
}

export const isTtChannel = () => {
    return !!getParam('ttclid')
}

// 获取播放模版
export const getPlayTemplate = () => {
    return getStorage(PLAY_TEMPLATE)
}


// 
export const initPlayTemplate = () => {
    if(+getPlayTemplate() === 2){
        return
    }
    const template = getParam('template')
    setStorage(PLAY_TEMPLATE, template)
}

export const APP_CONFIG = {
    orangenovel: {
        fbPixleId: '4068577130050988',
        lang: 'en',
        name: 'OrangeNovel',
        company: 'OrangeNovel.com',
        email: 'ops@novellettes.com',
    },
    melonflix: {
        fbPixleId: '4068577130050988',
        ttPixelId: 'D712JQBC77U2ACURRBN0',
        lang: 'en',
        name: 'DramaZ',
        company: 'melonflix.com',
        email: 'ops@novellettes.com',
    },
    default: {
        fbPixleId: '1081737203961773',
        ttPixelId: 'D712JQBC77U2ACURRBN0',
        moneySymbol: '$',
        company: 'melonflix.com',
        email: 'ops@novellettes.com',
        lang: 'en'
    }
}


export const getAppInfo = () => {
    const appId = getAppID()
    const obj = {
        name: APP_CONFIG[appId]?.name || APP_CONFIG['default'].name,
        company: APP_CONFIG[appId]?.company || APP_CONFIG['default'].company,
        fbPixleId: APP_CONFIG[appId]?.fbPixleId || APP_CONFIG['default'].fbPixleId,
        email: APP_CONFIG[appId]?.email || APP_CONFIG['default'].email,
    }
    return obj
}


export const isToufang = () => {
    return getParam('ch')
}

export const setUserInfo = (id, token) => {
    window[USER_ID_COOKIES_KEY] = id;
    window[USER_TOKEN_COOKIES_KEY] = token;
    Cookies.set(USER_ID_COOKIES_KEY, id, { expires: 365 })
    Cookies.set(USER_TOKEN_COOKIES_KEY, token, { expires: 365 })
    setStorage(USER_ID_COOKIES_KEY, id)
    setStorage(USER_TOKEN_COOKIES_KEY, token)
}

export const getUserInfo = () => {
    return {
        user_id: window[USER_ID_COOKIES_KEY] || Cookies.get(USER_ID_COOKIES_KEY) || getStorage(USER_ID_COOKIES_KEY),
        user_token: window[USER_TOKEN_COOKIES_KEY] || Cookies.get(USER_TOKEN_COOKIES_KEY) || getStorage(USER_TOKEN_COOKIES_KEY)
    }
}

export const isFacebookWebView = () => {
  const ua = window.navigator.userAgent;
  return /FB_IAB|FBAN|FBAV|FBWEBVIEW|FBANLITE|Facebook/i.test(ua);
};

export const isTiktokWebView = () => {
    // 方法1：检查用户代理(UA)标识
  const userAgent = navigator.userAgent.toLowerCase();
  const isTikTokUA = /(tiktok)|(musically)|(bytedance)/i.test(userAgent);
  
  // 方法2：检查TikTok特有的JS对象（更可靠）
  const isTikTokEnv = typeof webview !== 'undefined' && 
                     webview?.name === 'TikTok';
  
  // 方法3：检查TikTok特有的URL参数
  const urlParams = new URLSearchParams(window.location.search);
  const hasTikTokParam = urlParams.has('tt_webid') || 
                         urlParams.has('tt_chain_token');
  
  return isTikTokUA || isTikTokEnv || hasTikTokParam;
}


export const isToufangWebView = () => {
    // return true
    return isFacebookWebView() || isTiktokWebView();
}

export function setToufang() {
    if(!getParam('ch')){
        if(isToufangWebView()){
           const location = window.location
            let search = ''
            if(location.search){
                search = '&ch=1'
            }else{
                search = '?ch=1'
            }
            let pathname = location.pathname
            this.$router.push(`${pathname}${location.search}${search}`)
        }

    }
}